import { createAction } from 'redux-actions';
import { change } from 'redux-form';
import { map } from 'lodash';
import { batchActions } from 'redux-batched-actions';
import {
  EMPLOYEE_DETAIL_FETCH,
  EMPLOYEE_DETAIL_SUCCESS,
  EMPLOYEE_DETAIL_FAILURE
} from './actionTypes';
import api from '../../services/api';
import { EMPLOYEE_FORM_NAME } from '../EmployeeForm/constants';

//<<<---EMPLOYEE-DETAIL--->>>
export const employeeDetailFetch = createAction(EMPLOYEE_DETAIL_FETCH);
export const employeeDetailSuccess = createAction(EMPLOYEE_DETAIL_SUCCESS);
export const employeeDetailFailure = createAction(EMPLOYEE_DETAIL_FAILURE);

export const fetchEmployeeDetail = (id, lang) => async dispatch => {
  dispatch(employeeDetailFetch());
  try {
    const { data } = await api.get(`employee/${id}/${lang}`);

    const { showOnContact, photo } = data;

    const fieldNames = [
      'title',
      'description',
      'name',
      'surname',
      'job',
      'jobType',
      'jobDescription',
      'email',
      'telephone',
      'slug'
    ];

    const fieldChangeActions = map(fieldNames, fieldName =>
      change(EMPLOYEE_FORM_NAME, fieldName, data[fieldName])
    );
    fieldChangeActions.push(
      change(EMPLOYEE_FORM_NAME, 'photo', {
        src: `https://api.alfadent.ikiguys.net${photo}`
      })
    );

    fieldChangeActions.push(
      change(
        EMPLOYEE_FORM_NAME,
        'showOnContact',
        showOnContact && showOnContact === 'true'
      )
    );

    dispatch(batchActions(fieldChangeActions));
    dispatch(employeeDetailSuccess());
  } catch (error) {
    dispatch(employeeDetailFailure(error));
  }
};



// WEBPACK FOOTER //
// ./src/modules/EmployeeDetail/actions.js